module.exports = __webpack_public_path__ + "media/images/country_flags/ag-3fe3668e773a342329dcc0cca99aec31.png";